export default function MealCard({
  meal,
  onClick,
  footer,
  selected,
}) {
  return (
    <div
      className="ticket"
      onClick={onClick}
      style={{
        cursor: onClick ? "pointer" : "default",
        borderColor: selected ? "var(--accent)" : undefined,
      }}
    >
      
      {(meal.dayNumber || meal.mealType) && (
        <div className="ticket-meta" style={{ marginBottom: 6 }}>
          {meal.dayNumber && <span>DAY {meal.dayNumber}</span>}
          {meal.mealType && <span>{meal.mealType.toUpperCase()}</span>}
        </div>
      )}

      <h3 className="ticket-title">{meal.mealName}</h3>

      <div className="ticket-meta"  style={{
    display: "flex",
    flexDirection: "row",
    alignItems: "l",
    gap: "12px",
    flexWrap: "nowrap",
    marginBottom: "0px"
  }}>
        <span style={{marginTop:"-2px"}}> <span className="num">⏱{meal.cookTime}</span>m</span>
        <span>{meal.difficulty}</span>
        <span><span className="num">{meal.calories}</span> cal</span>
        {meal.estimatedCost !== undefined && (
          <span>$<span className="num">{meal.estimatedCost.toFixed(2)}</span></span>
        )}
      </div>

      {!!meal.missingIngredients?.length && (
        <div className="chip-row" style={{ marginTop: 10 }}>
          {meal.missingIngredients.map((item) => (
            <span key={item} className="pill warn">
              + {item}
            </span>
          ))}
        </div>
      )}

      {footer && <div style={{ marginTop: 12 }}>{footer}</div>}
    </div>
  );
}